// import React from 'react';
// import Someicon from './icon-list/Someicon';
// import FitIssue from './icon-list/FitIssue';

// const IconMap = {
//     Someicon,
//     FitIssue,
// }

// const DynamicIcon = ({ icon }) => {
//     if (!icon) return null;
//     const IconComponent = IconMap[icon];
//     if (!IconComponent) return null;
//     return <IconComponent />;
// };

// export default DynamicIcon;


import React, { useState, useEffect, Suspense } from 'react';

const DynamicIcon = ({ icon, fallback = null, ...props }) => {
    const [IconComponent, setIconComponent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!icon) {
            setLoading(false);
            return;
        }

        const loadIcon = async () => {
            try {
                setLoading(true);
                setError(null);

                // Dynamic import - this enables code splitting
                const iconModule = await import(`./icon-list/${icon}.js`);
                setIconComponent(() => iconModule.default);
            } catch (err) {
                console.warn(`Icon "${icon}" not found:`, err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        loadIcon();
    }, [icon]);

    if (!icon) return null;
    if (loading) return fallback || <div>Loading...</div>;
    if (error || !IconComponent) return fallback || <div>Icon not found</div>;

    return <IconComponent {...props} />;
};


export default DynamicIcon;